import { render, staticRenderFns } from "./detail-expired-kplh-k3l.vue?vue&type=template&id=42fa471c&scoped=true&"
import script from "./detail-expired-kplh-k3l.vue?vue&type=script&lang=js&"
export * from "./detail-expired-kplh-k3l.vue?vue&type=script&lang=js&"
import style0 from "./detail-expired-kplh-k3l.vue?vue&type=style&index=0&id=42fa471c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa471c",
  null
  
)

export default component.exports